import { render, staticRenderFns } from "./coverCropper.vue?vue&type=template&id=08b0b2fb&scoped=true&"
import script from "./coverCropper.vue?vue&type=script&lang=js&"
export * from "./coverCropper.vue?vue&type=script&lang=js&"
import style0 from "./coverCropper.vue?vue&type=style&index=0&id=08b0b2fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0b2fb",
  null
  
)

export default component.exports